export const keys = {
  token: 'sessionToken'
};

export const getToken = () =>
    JSON.parse(window.sessionStorage.getItem(keys.token)) || '';

export const setToken = token =>
  window.sessionStorage.setItem(keys.token, token);

export const revokeToken = () =>
  window.sessionStorage.removeItem(keys.token);

